import { Editor, type EditorEvent, type Events, type Ui } from 'tinymce';
import { NgZone } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/dynamicdialog';
import * as FlatModels from '@medsurf/flat-models';
import { AnnotationEditorDialogComponent } from "../../dialog/annotation-editor-dialog/annotation-editor-dialog.component";
import { firstValueFrom } from "rxjs";


export const register = (
	editor: Editor,
	zone: NgZone,
	translate: TranslateService,
	dialogService: DialogService
) => {

	const nodeChangedCallback = (
		buttonApi: Ui.Toolbar.ToolbarToggleButtonInstanceApi,
		event: EditorEvent<Events.NodeChangeEvent>
	) => {
		const element = (<HTMLElement>event.element);
		const isAnchor = element?.tagName?.toLowerCase() === 'a';
		const isMarkerLink = element?.classList?.contains('mds-marker');
		const hasSelectionContent = !!editor.selection.getContent();
		
		buttonApi.setEnabled(hasSelectionContent || isAnchor);
		buttonApi.setActive(isMarkerLink && isAnchor);
	}

	const onSetup = (buttonApi: Ui.Toolbar.ToolbarToggleButtonInstanceApi) => {
		editor.on('NodeChange', (event) => nodeChangedCallback(buttonApi, event));
		return () => {
		  	editor.off('NodeChange', (event) => nodeChangedCallback(buttonApi, event));
		};
	}

	const onAction = () => {
		const node: HTMLAnchorElement = <HTMLAnchorElement>editor.selection.getNode();
		const linkText: string = node?.pathname?.replace('/', '');
		const selection: string = editor.selection.getContent();
		let innerText: string = selection === node.innerText ? node.innerText : selection;
		if (!innerText) {
			innerText = node.innerText;
		}
		
		try {
			zone.run(async () => {
				editor.editorManager.focusedEditor = null;
				const ref = dialogService.open(AnnotationEditorDialogComponent, {
					header: translate.instant('global.link_edit'),
					data: {
						linkText
					},
					width: '30%',
				});
				const result = await firstValueFrom<FlatModels.EditorAuthorModels.AnnotationLinkEditorDialog>(ref.onClose)
				editor.editorManager.focusedEditor = editor;
				
				if (!result) return;
				if (linkText === result.linkText) return;
				editor.insertContent(`<a class="mds-marker" href="${result.linkText}">${innerText}</a>`);
			});
		} catch (err) {
			return;
		}
	}

	editor.ui.registry.addToggleButton('marker', {
        icon: 'marker',
        tooltip: 'Insert/edit annotation link',
        onAction,
        onSetup
      });
}